const primaryMain = '#006647';
const primaryMainOpacity = 'rgba(0, 102, 71, 0.9)';
const secondaryMain = '#008ECD';
const secondaryMainOpacity = 'rgba(0, 144, 205, 0.5)';
const secondaryLight = '#004159';
const tertiaryMain = '#004159';

export const palette = {
  primaryMain,
  primaryMainOpacity,
  primaryText: primaryMain,
  secondaryMain,
  secondaryMainOpacity,
  secondaryLight,
  secondaryText: secondaryMain,
  tertiaryMain,
  formNavBar: {
    currentStepButtonTextColor: tertiaryMain
  }
};
